export const NEGATIVE_CATEGORY_LABELS = {
  complaint: 'Жалоба',
  alert: 'Критичное обращение',
  negative: 'Жалоба'
};

export const NEGATIVE_SUB_CATEGORY_LABELS = {
  safety_issue: 'Риск безопасности/поломки',
  repeated_unresolved: 'Повторно не решено',
  no_clear_next_step: 'Нет ясного следующего шага',
  low_quality_call: 'Низкое качество звонка'
};

const humanizeCode = (value) =>
  String(value ?? '')
    .trim()
    .split('_')
    .filter(Boolean)
    .map((part) => part[0]?.toUpperCase() + part.slice(1))
    .join(' ');

/**
 * Код узнаётся по латинскому snake_case. Всё остальное — уже готовая подпись: legacy-колонки
 * хранят русский текст, а категории пакета узлов приезжают подписью из справочника. Прогонять
 * такую строку через humanizeCode нельзя: он приводит её к нижнему регистру и «Нарушение SLA»
 * превращается в «Нарушение Sla».
 */
const isCode = (value) => /^[a-z0-9_]+$/i.test(value);

const formatValue = (value, labels) => {
  if (!value) return '—';
  const trimmed = String(value).trim();
  if (!isCode(trimmed)) {
    return trimmed;
  }

  const key = trimmed.toLowerCase();
  return labels[key] ?? humanizeCode(key) ?? trimmed;
};

export const formatNegativeCategory = (value) => formatValue(value, NEGATIVE_CATEGORY_LABELS);

export const formatNegativeSubCategory = (value) => formatValue(value, NEGATIVE_SUB_CATEGORY_LABELS);
